/**
 * Public drug catalog read (M4-T04; M12-T06a). Per ADR-0028 there is **no
 * patient-facing stock**: the catalog carries only `prescription_only`, and
 * availability is answered per request by the pharmacies (medications flow).
 */
import { apiFetch } from '../lib/api'

/** A formulary catalog entry — no per-hospital stock. */
export type Drug = {
  id: string
  slug: string
  generic_name: string
  brand_name: string | null
  form: string
  strength: string
  prescription_only: boolean
}

export function drugsKey(q: string) {
  return ['drugs', q] as const
}

export function drugKey(slug: string) {
  return ['drug', slug] as const
}

/** GET /api/v1/drugs/{slug} — one catalog drug (the request-form header). */
export async function fetchDrug(
  slug: string,
  signal?: AbortSignal,
): Promise<Drug> {
  const opts = signal ? { signal } : {}
  const body = await apiFetch<{ data: Drug }>(`/api/v1/drugs/${slug}`, opts)
  return body.data
}

/** GET /api/v1/drugs?q= — the closed formulary catalog (name search). */
export async function fetchDrugs(
  q: string,
  signal?: AbortSignal,
): Promise<Drug[]> {
  const params = new URLSearchParams()
  if (q.trim()) params.append('q', q.trim())
  const qs = params.toString()
  const opts = signal ? { signal } : {}
  const body = await apiFetch<{ data: Drug[] }>(
    `/api/v1/drugs${qs ? `?${qs}` : ''}`,
    opts,
  )
  return body.data
}
